import React, { Fragment, useRef, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import ReactToPrint from "react-to-print";
import { useLocation } from 'react-router-dom';
import {
  HttpRequest,
  HttpRequestFileDownload,
} from "../../../utils/httpRequests";

const useStyles = makeStyles(() => ({
  page: {
    padding: 5,
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  barcodeContainer: {
    display: "flex",
    flexDirection: "column",
  },
  barcodeText: {
    textAlign: "center",
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginLeft: 100,
  },
  subTitle: {
    marginTop: 20,
  },
  tableContainer: {
    marginTop: 10,
  },
  table: {
    fontFamily: "arial, sans-serif",
    borderCollapse: "collapse",
    width: "100%",
  },
  tableContent: {
    border: "1px solid #dddddd",
    textAlign: "left",
    padding: 8,
  },
  footerContainer: {
    display: "flex",
    float: "right",
    marginTop: 70,
  },
  image: {
    border: "none",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
}));

const BarcodePrintView = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderItemId = searchParams.get('orderItemId');
  //   const urlParams = new URLSearchParams(window.location.search);
  //   console.log("searchParams: ", searchParams);
  // const orderItemId = urlParams.get('orderItemId');
  console.log('Order Item ID:', orderItemId);
  const pagestyle = `{ size: 2in 1in }`;
  const classes = useStyles();
  const componentRef = useRef();
  const [imageFile, setImageFile] = useState("");


  // useEffect(() => {
  //   const data = localStorage.getItem("ckBarcodeData") || "{}";
  //   const jsonData = JSON.parse(data) || {};
  //   const fileName = jsonData["fileName"];
  //   if (fileName) {
  //     setImageFile(fileName);
  //     window.print();
  //     setTimeout(function () {
  //       localStorage.removeItem("ckBarcodeData");
  //       window.close();
  //       if (!window.closed) {
  //         window.location = "#/sales-order";
  //       }
  //     }, 3000);
  //   } else {
  //     window.close();
  //     if (!window.closed) {
  //       window.location = "#/sales-order";
  //     }
  //   }
  // }, []);


  useEffect(() => {
    const data = localStorage.getItem("ckBarcodeData") || "{}";
    const jsonData = JSON.parse(data) || {};
    const fileName = jsonData["fileName"];

    if (fileName) {
      setImageFile(fileName);
    }
  }, []);


  // API call function
  const handleShippingLabelPrintClick = async () => {

    try {
      const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C06SalesOrderItemIsBarcodePrinted?orderItemId=${orderItemId}`;

      const data = new FormData();

      let result = await HttpRequest("POST", url, data, "authorize");

      if (result.isSuccess) {

        const existing = localStorage.getItem("ckBarcodeData");
        if (existing) {
          const parsed = JSON.parse(existing);
          parsed.isPrinted = true;
          localStorage.setItem("ckBarcodeData", JSON.stringify(parsed));
        }
        // localStorage.removeItem("ckBarcodeData");
        console.log("Print status updated successfully");
        window.close();
        return true;
      } else {
        console.error("Failed to update print status");
        window.close();
        return false;
      }
    } catch (error) {
      console.error("Error updating print status:", error);
      window.close();
      return false;
    }
  };



  return (
    <Fragment>
      <div ref={componentRef} className={classes.page}>
        <div
          style={{


            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start"


          }}
        >
          <img
            alt="Error getting barcode"
            width="600px"
            src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${imageFile}`}
          />
        </div>
      </div>
      <ReactToPrint
        onAfterPrint={() => { handleShippingLabelPrintClick() }}
        trigger={() => {
          return (
            <Button
              id="btnWorkorderPrint"
              style={{
                // display: "none",
                float: "right",
                marginTop: 40,
                marginRight: 20,
                textTransform: "capitalize",
                opacity: 0.8,
                marginLeft: "94%",
              }}
              color="primary"
              variant="contained"
            >
              Print
            </Button>
          );
        }}
        content={() => componentRef.current}
        pageStyle={pagestyle}
      // pageStyle="@page { size: A4}"
      />
    </Fragment>
  );
};

export default BarcodePrintView;
